import { EConfigurationNames, ISingleImageData } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';

//IMAGES
import img_auto from '@Buttons/AutoButton/icon_autoplay_horizontal.svg';
import img_play from '@Buttons/BigMultiButton/icon_play.svg';
import img_gamble from '@Buttons/GambleButton/icon_gamble_horizontal.svg';
import img_turbo from '@Buttons/TurboModeButton/icon_turbo_horizontal.svg';
import img_mute from '@Buttons/SoundButton/image_sound_on.svg';
import img_settings from '@Buttons/MenuButton/image_menu.svg';
import img_fullscreen from '@Buttons/FullscreenButton/image_fullscreen_in.svg';

const uiImagePaths: { [key: string]: string } = {
    auto: img_auto,
    play: img_play,
    gamble: img_gamble,
    turbo: img_turbo,
    mute: img_mute,
    settings: img_settings,
    fullscreen: img_fullscreen
};

export function getImagePathResolver(data: ISingleImageData, imgElement: boolean = false) {
    let path = '';
    let langPrefix = data.langSelector ? `_${ConfigLoader.urlParameters.languageCode}` : '';

    if (data.commonSrc) {
        if (uiImagePaths[data.commonSrc]) {
            path = uiImagePaths[data.commonSrc];
        } else {
            path = `${ConfigLoader.sharedResourcePath}/bitmaps/help/${data.commonSrc}${langPrefix}.svg?v=${ConfigLoader.getConfiguration(EConfigurationNames.VERSION).cacheVersion}`;
        }
    }

    if (data.src) {
        path = `${ConfigLoader.gameResourcePath}/bitmaps/ui/help/${data.src}?v=${ConfigLoader.getConfiguration(EConfigurationNames.VERSION).cacheVersion}`;
    }
    return path;
}
